import { useCoordinatedFormState } from '../useCoordinatedFormState';

interface IProps {
  sectionId: string;
  taskId: string;
}

/**
 * Hook che ritorna true se il form è in uno stato di errore.
 */
export function useIsCoordinatedFormError(props: IProps) {
  const { sectionId, taskId } = props;
  const { errors } = useCoordinatedFormState({
    name: sectionId,
    formId: taskId,
  });
  const isError = Object.keys(errors ?? {}).includes(sectionId);

  return { isError };
}
